/**
 * The month a period picker opens on: today's, as `YYYY-MM`.
 *
 * Both analytics screens — the merchant dashboard and the org consolidated
 * view — seed their picker with this, so it lives here rather than in either
 * container.
 */
export const currentYearMonth = (): string => {
  const now = new Date();
  return `${now.getFullYear()}-${(now.getMonth() + 1)
    .toString()
    .padStart(2, "0")}`;
};
